import { onUnmounted } from 'vue'

export enum GlobalEvents {
  PE_EDIT_SECTION = 'pe-edit-section',
  PE_ADD_SECTION_ITEM = 'pe-add-section-item',
  INLINE_EDIT = 'inline-edit',
  PE_ADD_CORE_SKILL = 'pe-add-core-skill',
  PE_REPORT_SECTION = 'pe-report-section',
  SKILL_HIGHLIGHT_HOVER_SKILL = 'skill-highlight-hover-skill',
  SKILL_HIGHLIGHT_CLICK_SKILL = 'skill-highlight-click-skill',
  SKILL_CLICK_TO_SCROLL = 'skill-click-to-scroll',
}

export const useGlobalListeners = () => {
  const activeListeners: { event: any; handler: any }[] = []

  onUnmounted(() => {
    if (activeListeners.length) {
      activeListeners.forEach(listener => {
        window.removeEventListener(listener.event, listener.handler)
      })
    }
  })

  const registerListener = (event: GlobalEvents, handler: any) => {
    window.addEventListener(event, handler)
    activeListeners.push({ event, handler })
  }

  const publishEvent = (event: GlobalEvents, data: any = {}) => {
    window.dispatchEvent(new CustomEvent(event, { detail: data }))
  }

  return {
    registerListener,
    publishEvent,
  }
}
